import type { Component } from "solid-js";
import { useI18n } from "@/api/i18n";
import { RootLayout } from "@/domains/auth/routes/layout";
import { MetaTitleWithSeparator } from "@/domains/business/seo";
import { NotFoundView } from "@/domains/error/components/not-found-view";

const NotFoundRoute: Component = () => {
  const { t } = useI18n();

  return (
    <RootLayout>
      <MetaTitleWithSeparator>{t("404.title")}</MetaTitleWithSeparator>
      <NotFoundView />
    </RootLayout>
  );
};

export default NotFoundRoute;
